<template>
    <v-container grid-list-lg>
        <v-layout>
            <v-flex xs12 class="elevation--6 orange--text text-xs-center display-1 font-weight-black my-5">{{$t('home.ourTopTours')}}</v-flex>
            <v-flex align-end class="my-4">
                <v-btn large class="orange" to="/tours">{{$t('home.showAllTours')}}</v-btn>
            </v-flex>
        </v-layout>
        <v-layout wrap>
            <v-flex xs12 sm12 md4 v-for="course in topTourCourses">
                <HomeActivitiesCard v-bind:courseData="course"></HomeActivitiesCard>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import HomeActivitiesCard from '@/components/ui/HomeActivitiesCard.vue';
export default {
  name: 'HomeTopActivities',
  components: {
    HomeActivitiesCard
  },
  computed: {
    topTourCourses() {
      let tourCourses = this.$store.getters.tourCourses;
      let topTourCourses = [tourCourses[0], tourCourses[1], tourCourses[3], tourCourses[4], tourCourses[5], tourCourses[6]]
      return topTourCourses;
    }
  },
  data: () => ({
  }),
};
</script>

<style scoped>
.home-hero {
    background: url('http://source.unsplash.com/0BhSKStVtdM');
    background-size: cover;
    width: 100%;
    height: 100%;
}
#homecontainer {
  max-height: 100vh;
}
</style>
